import { a } from '../global-constants';

const personalized = (state = false, { type, payload }) => {
	switch (type) {
		case a.SET_PERSONALIZED: {
			return payload;
		}
		default:
			return state;
	}
};

export default personalized;
